export default __webpack_public_path__ + "static/media/jewelry-dark-winter.cd98b376.png";